/**
 * Per-state easement law pages.
 *
 * The 50-state prescriptive easement reference used to live only inside the
 * /resources hub, where it was invisible to search engines. Each state now has
 * its own indexable URL derived from the same data, so there is exactly one
 * source of truth for the content and for the sitemap.
 */
import {
  PRESCRIPTIVE_EASEMENT_LAW_SORTED,
  type StateEasementLaw,
} from "@/data/prescriptiveEasementLaw";
import type { SitemapEntry } from "@/lib/seo-routes";

/** "North Carolina" -> "north-carolina" */
export function stateSlug(stateName: string): string {
  return stateName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
}

export function stateLawPath(law: StateEasementLaw): string {
  return `/easement-law/${stateSlug(law.stateName)}`;
}

export function findStateLawBySlug(slug: string | undefined): StateEasementLaw | undefined {
  if (!slug) return undefined;
  const normalized = slug.trim().toLowerCase();
  return PRESCRIPTIVE_EASEMENT_LAW_SORTED.find((law) => stateSlug(law.stateName) === normalized);
}

/** Sitemap rows for every state page. */
export const STATE_LAW_ENTRIES: SitemapEntry[] = PRESCRIPTIVE_EASEMENT_LAW_SORTED.map((law) => ({
  path: stateLawPath(law),
  changefreq: "monthly" as const,
  priority: "0.6",
}));
